import { render, staticRenderFns } from "./PreRegistrationPanel.vue?vue&type=template&id=5aaab5e8"
import script from "./PreRegistrationPanel.vue?vue&type=script&lang=js"
export * from "./PreRegistrationPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports